// amazon-cognito-identity-js references Node's `global`, which is undefined in
// browser bundles and throws at module-eval (blanking the SPA under Vite).
// Alias it to globalThis. Must be imported FIRST in main.tsx, before any module
// that pulls in the Cognito SDK.
(globalThis as unknown as { global?: unknown }).global ??= globalThis;
export {};
